import { useDispatch } from "react-redux";
import { CHECKOUT_PAGES_ACTION_TYPES } from "../constants/CheckoutPagesReducer";
import { useCheckoutBasicDetailsContext } from "../modules/CheckoutBasicDetailsContextProvider";

/**
 * This hook returns a setter to toggle the redux state to see if
 * the custom question file is being uploading
 * @returns setIsCustomQuestionFileUploading setter to change the value of loader state
 */
export const useSetIsFileUploading = () => {
    const dispatch = useDispatch();
    const { listingUuid } = useCheckoutBasicDetailsContext();

    const setIsCustomQuestionFileUploading = (loadingState: {
        [key: string]: boolean;
    }) => {
        dispatch({
            type: CHECKOUT_PAGES_ACTION_TYPES.SET_IS_CUSTOM_QUESTION_FILE_UPLOADING,
            payload: {
                listingUuid,
                data: {
                    ...loadingState,
                },
            },
        });
    };

    return {
        setIsCustomQuestionFileUploading,
    };
};
